// Editor HTML utilities moved from TextEditor.vue
const isTrulyEmpty = (el: Element): boolean => {
  if (!el.textContent?.trim()) {
    return true
  }
  return /^(<br\s*\/?>(?:&nbsp;)?|\s)+$/i.test(el.innerHTML.trim())
}

const normalizeBrTags = (innerHTML: string): string => {
  const withoutLeadingBr = innerHTML.replace(/^(<br\s*\/?>)+/gi, '')
  const withoutTrailingBr = withoutLeadingBr.replace(/(<br\s*\/?>)+$/gi, '')
  return withoutTrailingBr.replace(/(<br\s*\/?>){2,}/gi, '<br>')
}

const removeEmptyElements = (container: ParentNode): void => {
  container.querySelectorAll('li').forEach((li) => {
    if (!isTrulyEmpty(li)) {
      return
    }
    li.remove()
  })
  container.querySelectorAll('p, h1, h2, h3, h4, h5, h6, div, span, blockquote').forEach((el) => {
    if (!isTrulyEmpty(el)) {
      return
    }
    el.remove()
  })
  container.querySelectorAll('ul, ol').forEach((list) => {
    if (list.querySelector('li') && !isTrulyEmpty(list)) {
      return
    }
    list.remove()
  })
}

const CLEAN_HTML_ITERATIONS = 5

const cleanHTML = (html: string): string => {
  if (!html) {
    return ''
  }

  const temp = document.createElement('template')
  temp.innerHTML = html

  Array.from({ length: CLEAN_HTML_ITERATIONS }).forEach(() => removeEmptyElements(temp.content))

  temp.content.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li').forEach((el) => {
    el.innerHTML = normalizeBrTags(el.innerHTML)
  })

  const rawCleaned = temp.innerHTML.trim()
  const withoutFinalBr = rawCleaned.replace(/(<br\s*\/?>)+$/gi, '')
  return withoutFinalBr.replace(/(<p>\s*<\/p>)+$/gi, '')
}

const stripSourcePrefix = (key: string): string => key.replace(/^source\//, '')

const stripHTML = (html: string | undefined | null): string => {
  if (!html) {
    return ''
  }

  return html
    .replace(/<br+\/?>/ig, ' ')
    .replace(/<\/?[^>]+>/ig, '')
}

const stringToElement = (str: string): Element => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(str, 'application/xml')
  return doc.documentElement
}

const replaceHeadingElements = (html: string) => (
  html
    .replaceAll('<h1>', '<strong style="font-size: 2.25rem !important; display: block; margin-bottom: 0.5rem; font-weight: 800">')
    .replaceAll('</h1>', '</strong>')

    .replaceAll('<h2>', '<strong style="font-size: 2.25rem !important; display: block; font-weight: 800">')
    .replaceAll('</h2>', '</strong>')

    .replaceAll('<h3>', '<strong style="font-size: 1.75rem !important; display: block; margin-bottom: 0.5rem; font-weight: 800">')
    .replaceAll('</h3>', '</strong>')

    .replaceAll('<h4>', '<strong style="font-size: 1.5rem !important; display: block; margin-bottom: 0.5rem;">')
    .replaceAll('</h4>', '</strong>')

    .replaceAll('<h5>', '<strong style="display: block !important; margin-bottom: 0.5rem;">')
    .replaceAll('</h5>', '</strong>')
)

/**
 * Replaces &nbps; etc to their actual character
 */
const htmlEntitiesDecoder = () => {
  let decodeElement: HTMLTextAreaElement

  const decode = (text: string) => {
    if (!text) {
      return ''
    }

    if (!decodeElement && typeof document !== 'undefined') {
      decodeElement = document.createElement('textarea')
    }

    if (!decodeElement) {
      return String(text)
    }

    decodeElement.innerHTML = text

    return decodeElement.value
  }

  return {
    decode,
  }
}

export {
  isTrulyEmpty,
  normalizeBrTags,
  removeEmptyElements,
  CLEAN_HTML_ITERATIONS,
  cleanHTML,
  stripSourcePrefix,
  stripHTML,
  stringToElement,
  replaceHeadingElements,
  htmlEntitiesDecoder,
}
